<template >
  <el-row style="padding-top: 5px">
    <el-col :span="6" >
      <span v-if="channel_type == '1'">
      <svg class="icon" aria-hidden="true"
        style="width: 1.8em;height: 1.8em;position:relative;top:2px;left:3px;padding-right: 7px"
        >
        <use xlink:href="#the_third_iconweixin1"></use>
      </svg>
    </span>
    <span v-else-if="channel_type == '2'">
      <svg class="icon" aria-hidden="true"
           style="width: 1.4em;height: 1.4em;position:relative;top:2px;left:3px;padding-right: 7px">
        <use xlink:href="#the_third_iconqq" id="icon_qq"></use>
      </svg>
    </span>
    <span v-else-if="channel_type == '3'">
      <svg class="icon" aria-hidden="true"
           style="width: 1.3em;height: 1.3em;position:relative;top:2px;left:2px;padding-right: 5px">
        <use xlink:href="#the_third_icondingding1"></use>
      </svg>
    </span>
    <span v-else-if="channel_type == '4'">
      <svg class="icon" aria-hidden="true" style="width: 2.0em;height: 2.0em;position:relative;top:0px;">
        <use xlink:href="#the_third_iconyoujian1"></use>
      </svg>
    </span>
    <span v-else-if="channel_type == '5'">
      <svg class="icon" aria-hidden="true"
           style="width: 1.8em;height: 1.8em;position:relative;top:2px;padding-right: 2px">
        <use xlink:href="#the_third_iconduanxin6"></use>
      </svg>
    </span>
    <span v-else>
      <svg class="icon" aria-hidden="true"
           style="width: 1.5em;height: 1.5em;position:relative;top:4px;left:1px;padding-right: 2px">
        <use xlink:href="#the_third_iconqita4"></use>
      </svg>
    </span>

    </el-col>

    <el-col :span="18">
      <span class="show_title">{{name}}</span>
    </el-col>


<!--    <label class="show_title" ></label>-->
  </el-row>

</template>
<script>
  export default {
    props: {
      channel_type: {
        type: String,
      },
      name:{
        type:String
      }
    },
    data() {
      return {}
    }
  }
</script>
<style scoped>
   .show_title {

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// channel_type_show.vue?819c48de